import styled from "styled-components";

export const SignUpFormLayout = styled.form`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;

  input::placeholder {
    font-size: 1.5rem;
  }
`;

export const SignUpContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
`;

export const InputBoxLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;

  label {
    padding-left: 4px;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray};
  }

  .error-text {
    padding-left: 6px;
    color: ${(props) => props.theme.colors.red};
  }
`;

export const InputBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 6px;
    padding: 15px;
    outline: none;
    transition: all 0.3s;
    font-size: 1.6rem;

    &:focus {
      border: 1px solid ${(props) => props.theme.colors.primary};
    }
  }

  @media (min-width: 412px) {
    padding: 12px;
  }
`;

export const GenderBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  div {
    width: 100%;
    padding: 6px;
    font-size: 1.6rem;
    text-align: center;
    background: ${(props) => props.theme.colors.inputBorder};
    color: ${(props) => props.theme.colors.white};

    &.gender-male-active {
      border-radius: 4px 0 0 4px;
      background: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};
    }

    &.gender-female-active {
      border-radius: 0 4px 4px 0;
      background: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};
    }

    &.gender-male {
      border-radius: 4px 0 0 4px;
    }

    &.gender-female {
      border-radius: 0 4px 4px 0;
    }
  }
`;

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-shrink: 0;
  margin-top: 20px;
  width: 100%;

  .small {
    width: 50%;
  }
`;

export const CautionContextBox = styled.div`
  font-size: 1.23rem;
  display: flex;
  gap: 4px;
  color: ${(props) => props.theme.colors.gray};
`;

export const LabelContextBox = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;

export const InputContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const InputContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SignUpFormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
  margin-bottom: 20px;
`;

export const SignUpFormHeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const SignUpStepBox = styled.div`
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  padding: 3px 12px;
  font-size: 1.4rem;
  font-weight: 600;
`;

export const SignUpStepTitle = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
`;

export const SignUpFormContentTitle = styled.div`
  font-size: 2rem;
  font-weight: 500;
  white-space: nowrap;

  span {
    width: fit-content;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primary};
  }
`;
